module.exports = __webpack_public_path__ + "static/img/Frame1765.7896f1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/Frame1765.png
// module id = DMyG
// module chunks = 12